import { useLocation } from 'react-router-dom';
import { Text } from '@epam/promo';
import cloudImage from 'assets/icons/cloud.svg';
import botImage from 'assets/icons/bot-pic.svg';
import botNotFoundImage from 'assets/icons/task-not-found.svg';

import { taskRoutes } from 'router/taskRoutes';
import { BlankBlockProps } from './BlankBlock.model';
import css from './BlankBlock.module.scss';

export const BlankBlock = ({
  message = 'Please add new data',
  header = 'Nothing to display yet',
}: BlankBlockProps) => {
  const location = useLocation();

  return (
    <div className={css.blank}>
      <div className={css.blank__container}>
        <img alt="A background" src={cloudImage} />
        <div className={css.blank__info}>
          <Text
            color="gray90"
            cx={css.blank__title}
            fontSize="18"
            lineHeight="24">
            {header}
          </Text>
          <Text color="gray80" cx={css.body} fontSize="14" lineHeight="18">
            {message}
          </Text>
        </div>
      </div>
      <img
        alt="Bot"
        className={css.blank__image}
        src={
          location.pathname === taskRoutes.notFound
            ? botNotFoundImage
            : botImage
        }
      />
    </div>
  );
};
